import { render } from "./ShopPurchases.vue?vue&type=template&id=01111e76"
import script from "./ShopPurchases.vue?vue&type=script&lang=ts"
export * from "./ShopPurchases.vue?vue&type=script&lang=ts"
script.render = render

export default script